<div>
  <div class="header-style">
    <div class="h-100">
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      <mat-icon data-testid="invite_manufacturer_button" (click)="inviteManufaturer()" color="accent" class="cursor add-icon" aria-hidden="false" i18n-aria-label aria-label="Invite Manufacturer">person_add_alt_1</mat-icon>
      
      @if (invitationsList.length > 0) {
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item i18n="@@exportAsCSV" (click)="exportReviewInvitations(1)">Export as CSV</button>
          <button mat-menu-item i18n="@@exportAsPDF" (click)="exportReviewInvitations(2)">Export as PDF</button>
          <button mat-menu-item i18n="@@exportAsExcel" (click)="exportReviewInvitations(3)">Export as Excel</button>
        </mat-menu>
        <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" [matMenuTriggerFor]="exportMenu" i18n-aria-label aria-label="Export"></mat-icon>
      }

      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input data-testid="invitation_search_input" i18n-placeholder="@@searchPlaceholder" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon data-testid="invitationt_clear_button" class="cursor" matSuffix (click)="clearSearch()" i18n-aria-label aria-label="Clear">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="invitation_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-aria-label aria-label="Search"></mat-icon>
    </div>
  </div>

  @for (item of invitationsList; track item; let itemIndex = $index) {
    <mat-card class="{{(itemIndex % 2 === 0 ? 'lite-box-without-img mr-16 ' : 'lite-box-without-img')}}">
      <mat-card-content class="content-box">
        <div class="flex-grow cursor w-90">
          <div class="mat-subtitle-1 mb-10" matTooltip ellipsisTooltip>{{item.manufacturerContactName}}</div>
          <div class="mat-caption mb-8" matTooltip ellipsisTooltip>{{item.email}}</div>
          <div class="mat-caption" matTooltip ellipsisTooltip>{{item.phone}}</div>
        </div>
        @if (!item.allowToSendReminder) {
          <mat-icon i18n-aria-label aria-label="Email not sent" class="email-icon">email</mat-icon>
        }
        @if (item.allowToSendReminder) {
          <mat-icon (click)="resendInvitation(item)" class="cursor" color="accent" i18n-aria-label aria-label="Resend invitation">email</mat-icon>
        }
      </mat-card-content>
    </mat-card>
  }

  @if (invitationsList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-aria-label aria-label="No invitations found">
  }
</div>